'use client';

import Box from '@mui/material/Box';
import { Iconify } from 'src/components/iconify';
import { GRUND, hexTillRgba } from 'src/components/rörelse';
import { RouterLink } from 'src/routes/components';
import { paths } from 'src/routes/paths';
import { grannar, type Presentationsslug } from '../presentationer';

const RUTT: Record<Presentationsslug, string> = {
    autopilot: paths.presentation.autopilot,
    handelser: paths.presentation.händelser,
    bank: paths.presentation.bank,
    styrelsen: paths.presentation.styrelsen,
    'mitt-hem': paths.presentation.mittHem
};

export function PresentationsNav({ nuvarande }: { nuvarande: Presentationsslug }) {
    const { föregående, nästa } = grannar(nuvarande);

    return (
        <Box
            component="nav"
            aria-label="Fler presentationer"
            sx={{
                position: 'relative',
                zIndex: 1,
                display: 'flex',
                flexWrap: 'wrap',
                gap: 2,
                justifyContent: 'space-between',
                alignItems: 'stretch',
                px: { xs: 3, sm: 6, md: 10 },
                py: { xs: 6, md: 9 },
                borderTop: `1px solid ${GRUND.kant}`
            }}
        >
            <Länk href={RUTT[föregående.slug]} riktning="bak" titel={föregående.titel} />
            <Länk href={paths.presentation.root} riktning="alla" titel="Alla presentationer" />
            <Länk href={RUTT[nästa.slug]} riktning="fram" titel={nästa.titel} />
        </Box>
    );
}

function Länk({
    href,
    riktning,
    titel
}: {
    href: string;
    riktning: 'bak' | 'fram' | 'alla';
    titel: string;
}) {
    return (
        <Box
            component={RouterLink}
            href={href}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                textDecoration: 'none',
                color: GRUND.dämpad,
                fontSize: 15,
                px: 2,
                py: 1.25,
                borderRadius: 1.5,
                border: `1px solid ${hexTillRgba('#F2F3F7', 0.12)}`,
                transition: 'color .18s, border-color .18s',
                '&:hover': { color: GRUND.text, borderColor: hexTillRgba('#F2F3F7', 0.3) }
            }}
        >
            {riktning === 'bak' ? <Iconify icon="eva:arrow-ios-back-fill" width={16} /> : null}
            <span>{titel}</span>
            {riktning === 'fram' ? <Iconify icon="eva:arrow-ios-forward-fill" width={16} /> : null}
        </Box>
    );
}
